<template>
  <div class="CollaborativePersonnel">
    <el-form :model="form" inline>
      <el-table
        :data="form.contractCollectionPlanList"
        align="left"
        class="tablePage employeelist xzl-el-table-class"
        style="width: 100%"
      >
        <el-table-column width="160px" label="人员名称">
          <div slot-scope="scope">
            <el-select
              v-if="scope.row.isEditing"
              v-model.number="
                form.contractCollectionPlanList[scope.$index].teamworkUserId
              "
              filterable
              @change="(v) => handleChange(v, scope.$index)"
              reserve-keyword
              placeholder="请输入"
            >
              <el-option
                v-for="item in peopleList"
                :key="item.userId"
                :label="item.nickname"
                :value="item.userId"
              >
              </el-option>
            </el-select>

            <span v-else>{{ scope.row.teamworkUserName }}</span>
          </div>
        </el-table-column>
        <el-table-column label="分配百分比">
          <div slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.row.isEditing"
              type="number"
              placeholder="0"
              v-model.number="
                form.contractCollectionPlanList[scope.$index].rate
              "
            ></el-input>
            <span v-else>{{ scope.row.rate }}</span>
          </div>
        </el-table-column>
        <el-table-column label=" "></el-table-column>
        <el-table-column label="操作" width="100px" v-if="status ===4">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isEditing"
              @click="handleRowSaveOrEdit(scope.$index, 1)"
              type="text"
              size="small"
              >保存</el-button
            >
            <el-button
              v-else
              type="text"
              @click="handleRowSaveOrEdit(scope.$index, 2)"
              size="small"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDeleteRow(scope.$index)"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="tableNoData">
            <div class="bgBox iconfont iconzanwu"></div>
            <div class="text">暂时没有数据呀～</div>
          </div>
        </template>
      </el-table>
      <div v-if="status === 4" class="add-plat-btn" @click="handleAddPlan">添加协同人员</div>
    </el-form>
  </div>
</template>

<script>
import {
  saveContractCollectionPlan,
  removeContractCollectionPlan,
} from "@/api/ContractManagement";
import { getUserSimpleList } from "@/api/ElevatorManagement";
export default {
  data() {
    return {
      peopleList: [],
      canSearch: true,
      form: {
        contractCollectionPlanList: [
          {
            imageUrl: null,
            rate: 0,
            teamworkUserId: null,
            teamworkUserName: null,
            isEditing: true
          },
        ],
      },
    };
  },
  props: ["peoples", "status"],
  mounted() {
    this.getUserSimpleListFun();
  },
  methods: {
    handleChange(v, index) {
      const item = this.peopleList.find((item) => item.userId === v);
      let row = this.form.contractCollectionPlanList[index];
      if (item) {
        this.$set(row, "teamworkUserName", item.nickname);
      }
    },
    async getUserSimpleListFun(v = "") {
      this.canSearch = false;
      const res = await getUserSimpleList({ keyword: v, size: 1000 });
      if (res.code === 200) {
        this.peopleList = res.data;
      }
      this.canSearch = true;
    },
    handleRowSaveOrEdit(index, type) {
      if (type === 1) {
        // 保存
          this.form.contractCollectionPlanList[index].isEditing = false;
          this.$emit("confirm", this.form.contractCollectionPlanList);
      } else if (type === 2) {
        // 编辑
        this.form.contractCollectionPlanList[index].isEditing = true;
      }
    },
    async saveContractCollectionPlan(val) {
      let params = { ...val };
      params.contractId = this.contractId;
      params.updatePlan = 1;
      params.receivableAmount = params.receivableAmount * 1;
      const res = await saveContractCollectionPlan(params);
      if (res.code === 200) {
        let message = "添加成功";
        if (params.id) {
          message = "编辑成功";
        }
        this.$message.success(message);
        val.id = res.data;
        val.isEditing = false;
      }
    },
    handleDeleteRow(index) {
      if (this.contractId) {
        this.removeContractCollectionPlan(index);
      } else {
        this.form.contractCollectionPlanList.splice(index, 1);
        this.$emit("confirm", this.form.contractCollectionPlanList);
      }
    },
    async removeContractCollectionPlan(index) {
      const res = await removeContractCollectionPlan({
        idList: [this.form.contractCollectionPlanList[index].id],
      });
      if (res.code === 200) {
        this.$message.success("删除成功");
        this.form.contractCollectionPlanList.splice(index, 1);
      }
    },
    handleAddPlan() {
      this.form.contractCollectionPlanList.push({
        imageUrl: null,
        rate: 0,
        teamworkUserId: null,
        teamworkUserName: null,
        isEditing: true
      });
    },
  },
  watch: {
    peoples: {
      handler(newVal) {
        if (newVal && newVal.length) {
          const arr = JSON.parse(JSON.stringify(newVal));
          this.form.contractCollectionPlanList = arr.map((item) => ({
            ...item,
            isEditing: false,
            rate: item.rate || 0
          }));
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.CollaborativePersonnel {
  .add-plat-btn {
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #ccc;
    border: 1px dashed #ccc;
    margin-top: 16px;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      color: #5b8cff;
      border-color: #5b8cff;
    }
  }
  .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  .el-input__icon {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AnnualInspection/components/CollaborativePersonnel.vue